import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

export function PartyPage({ kind, title, subtitle }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const empty = { name: "", email: "", phone: "", address: "", npwp: "", notes: "", kind };
  const [form, setForm] = useState(empty);

  const load = () => api.get(`/parties?kind=${kind}`).then(r => setItems(r.data));
  useEffect(() => { load(); }, [kind]);

  const save = async () => {
    try {
      if (editing) await api.put(`/parties/${editing.id}`, form);
      else await api.post("/parties", form);
      toast.success("Tersimpan");
      setOpen(false); setEditing(null); setForm(empty); load();
    } catch (e) { toast.error("Gagal menyimpan"); }
  };
  const remove = async (id) => {
    if (!confirm("Hapus data ini?")) return;
    await api.delete(`/parties/${id}`); toast.success("Dihapus"); load();
  };
  const edit = (it) => { setEditing(it); setForm({ ...empty, ...it }); setOpen(true); };

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-tag">Master Data</div>
          <h1 className="font-display text-4xl tracking-tight mt-1">{title}</h1>
          <p className="text-sm text-forest-400 mt-2">{subtitle}</p>
        </div>
        <Dialog open={open} onOpenChange={(v)=>{ setOpen(v); if(!v){setEditing(null); setForm(empty);} }}>
          <DialogTrigger asChild>
            <Button data-testid={`btn-add-${kind}`} className="rounded-sm bg-[#2D4739] hover:bg-[#22362B] gap-2"><Plus size={16}/> Tambah</Button>
          </DialogTrigger>
          <DialogContent className="bg-[#FDFDFB] rounded-sm">
            <DialogHeader><DialogTitle className="font-display">{editing ? "Ubah" : "Tambah"} {title}</DialogTitle></DialogHeader>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="sm:col-span-2"><Label>Nama</Label><Input data-testid={`inp-${kind}-name`} value={form.name} onChange={e=>setForm({...form, name:e.target.value})} /></div>
              <div><Label>Email</Label><Input value={form.email||""} onChange={e=>setForm({...form, email:e.target.value})} /></div>
              <div><Label>Telepon</Label><Input value={form.phone||""} onChange={e=>setForm({...form, phone:e.target.value})} /></div>
              <div className="sm:col-span-2"><Label>Alamat</Label><Textarea value={form.address||""} onChange={e=>setForm({...form, address:e.target.value})} /></div>
              <div><Label>NPWP</Label><Input value={form.npwp||""} onChange={e=>setForm({...form, npwp:e.target.value})} /></div>
              <div><Label>Catatan</Label><Input value={form.notes||""} onChange={e=>setForm({...form, notes:e.target.value})} /></div>
            </div>
            <DialogFooter><Button data-testid={`btn-save-${kind}`} onClick={save} className="rounded-sm bg-[#2D4739] hover:bg-[#22362B]">Simpan</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="card-grid overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-forest-100">
              <th className="text-left px-4 py-3 label-tag">Nama</th>
              <th className="text-left px-4 py-3 label-tag">Email</th>
              <th className="text-left px-4 py-3 label-tag">Telepon</th>
              <th className="text-left px-4 py-3 label-tag">Alamat</th>
              <th className="text-right px-4 py-3 label-tag">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="text-center py-12 text-forest-400">Belum ada data</td></tr>}
            {items.map(it => (
              <tr key={it.id} className="data-row border-b border-forest-100">
                <td className="px-4 py-3 font-medium">{it.name}</td>
                <td className="px-4 py-3 text-forest-400">{it.email||"-"}</td>
                <td className="px-4 py-3 text-forest-400">{it.phone||"-"}</td>
                <td className="px-4 py-3 text-forest-400 truncate max-w-[300px]">{it.address||"-"}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={()=>edit(it)} data-testid={`btn-edit-${it.id}`} className="p-1.5 hover:bg-forest-50"><Pencil size={14}/></button>
                  <button onClick={()=>remove(it.id)} data-testid={`btn-del-${it.id}`} className="p-1.5 hover:bg-forest-50 text-[#C45A3D]"><Trash2 size={14}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function Clients() { return <PartyPage kind="client" title="Klien" subtitle="Daftar pelanggan / customer bisnis Anda." />; }
